/**
 * Keep multi-word city names (and optional ", ST") from wrapping mid-name
 * by wrapping the location in a nowrap span. Safe on already-resolved HTML.
 */
export function keepLocationTogether(
  html: string,
  city: string | null | undefined,
  state: string | null | undefined,
): string {
  const cityStr = (city && String(city).trim()) || '';
  if (!cityStr || !html.includes(cityStr)) return html;

  const stateStr = (state && String(state).trim()) || '';
  const location = stateStr ? `${cityStr}, ${stateStr}` : cityStr;
  const target = html.includes(location) ? location : cityStr;

  const cityEscaped = cityStr.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  if (new RegExp(`white-space:\\s*nowrap[^>]*>[^<]*${cityEscaped}`).test(html)) {
    return html;
  }

  const targetEscaped = target.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  return html.replace(
    new RegExp(targetEscaped, 'g'),
    `<span style="white-space:nowrap">${target}</span>`,
  );
}

/**
 * Keep "at {property name}" from leaving a lone "at" at the end of a line.
 */
export function keepPropertyNameTogether(
  html: string,
  name: string | null | undefined,
): string {
  const nameStr = (name && String(name).trim()) || '';
  if (!nameStr || !html.includes(nameStr)) return html;

  const atName = `at ${nameStr}`;
  if (!html.includes(atName)) return html;

  const atNameEscaped = atName.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  if (new RegExp(`white-space:\\s*nowrap[^>]*>[^<]*${atNameEscaped}`).test(html)) {
    return html;
  }

  return html.replace(
    new RegExp(atNameEscaped, 'g'),
    `<span style="white-space:nowrap">${atName}</span>`,
  );
}

export function stripWrappingParagraph(html: string): string {
  const trimmed = html.trim();
  const wrap = trimmed.match(/^<p>([\s\S]*)<\/p>$/);
  if (wrap && !/<p[\s>]|<div[\s>]|<h[1-6][\s>]/i.test(wrap[1])) {
    return wrap[1];
  }
  return html;
}
